import { ContactPanel } from './components/ContactPanel';
import { Hero } from './components/Hero';
import { PressCta } from './components/PressCta';
import { ResourcesAndSocial } from './components/ResourcesAndSocial';
import { Services } from './components/Services';

/** Each section owns its bottom padding. */
export const PageBody = () => {
	return (
		<div>
			<Hero />
			<ContactPanel />
			<Services />
			<ResourcesAndSocial />
			<PressCta />
		</div>
	);
};
